<ion-app>
  <ion-router-outlet></ion-router-outlet>

  <!-- Custom loader - displays over entire app -->
  <app-custom-loader
    [isVisible]="(loaderService.isLoading$ | async) || false"
    [message]="(loaderService.currentMessage$ | async) || 'Laster...'"
  ></app-custom-loader>

  <!-- Where the consent banner igive.no serves mounts (ConsentUiService). Inside
       ion-app, so Ionic's overlays and the loader stay above it as before. -->
  <div id="igive-consent"></div>
</ion-app>
